import React from "react";
import {StyleSheet, Text, View} from "react-native";
import {ArrowLeft} from "lucide-react-native";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";
import {PlayerButton} from "./PlayerPrimitives";
import {playerFont} from "../../theme/tokens";
import {isTelevisionRuntime} from "../../utils/platformCapabilities";

export function PlayerTopBar({ width, safeTop, showBack, showTitle, showFinishTime, title, finishesAt, onBack, onFocusChange, onActivity }: { width: number; safeTop: number; showBack: boolean; showTitle: boolean; showFinishTime: boolean; title: string; finishesAt: string; onBack: () => void; onFocusChange: (focused: boolean) => void; onActivity: () => void }) {
  const television = isTelevisionRuntime();
  return (
    <View style={[styles.topBar, { paddingTop: 16 + safeTop }]}>
      <Svg pointerEvents="none" width={width} height={84} style={styles.topGradient}>
        <Defs><LinearGradient id="player-top-fade" x1="0" y1="0" x2="0" y2="1"><Stop offset="0" stopColor="#000" stopOpacity={0.75} /><Stop offset="1" stopColor="#000" stopOpacity={0} /></LinearGradient></Defs>
        <Rect width={width} height={84} fill="url(#player-top-fade)" />
      </Svg>
      {showBack ? <PlayerButton label="Back" controllerFocusable={!television} onPress={onBack} large onFocusChange={onFocusChange} onActivity={onActivity}><ArrowLeft color="rgba(255,255,255,0.90)" size={24} /></PlayerButton> : null}
      {showTitle ? (
        <View style={styles.topTitle}>
          <Text numberOfLines={1} style={[styles.topSeries, television && styles.topSeriesTelevision]}>{title}</Text>
          {showFinishTime && finishesAt ? <Text style={[styles.finishTime, television && styles.finishTimeTelevision]}>Finishes at {finishesAt}</Text> : null}
        </View>
      ) : <View style={styles.topTitle} />}
    </View>
  );
}

const styles = StyleSheet.create({
  topBar: { minHeight: 72, padding: 16, flexDirection: "row", alignItems: "center", gap: 16 },
  topGradient: { position: "absolute", top: 0, left: 0 },
  topTitle: { flex: 1 },
  topSeries: { color: "#fff", fontFamily: playerFont, fontSize: 16, lineHeight: 20, fontWeight: "600" },
  topSeriesTelevision: { fontSize: 20, lineHeight: 26 },
  finishTime: { marginTop: 2, color: "rgba(255,255,255,0.60)", fontFamily: playerFont, fontSize: 12, lineHeight: 16, fontWeight: "600" },
  finishTimeTelevision: { marginTop: 3, fontSize: 15, lineHeight: 20 },
});
